import { useEffect, useRef } from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import "./transcriptsectioninterview.css";

export function TranscriptSection({
  transcripts,
}) {
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop =
        scrollContainerRef.current.scrollHeight;
    }
  }, [transcripts]);

  return (
    <Paper className="transcript-paper">
      {/* Header */}
      <Box className="transcript-header">
        <Typography className="transcript-header-title">
          Live Transcript
        </Typography>
      </Box>

      {/* Transcripts List */}
      <Box
        ref={scrollContainerRef}
        className="transcript-scroll-container"
      >
        {transcripts.length === 0 ? (
          <Box className="transcript-empty-state">
            <Typography variant="body2" color="textSecondary">
              Waiting for conversation to start...
            </Typography>
          </Box>
        ) : (
          <List className="transcript-list">
            {transcripts.map((item, index) => (
              <ListItem
                key={item.id}
                className={`transcript-list-item ${index < transcripts.length - 1 ? 'transcript-list-item-border' : ''}`}
              >
                {/* Question/Statement - Only show for interviewer */}
                {item.role !== "user" && (
                  <Typography className="transcript-question-text">
                    {item.text}
                  </Typography>
                )}

                {/* Speaker Name */}
                <Box className="transcript-speaker-container">
                  <Typography className="transcript-speaker-name">
                    {item.role === "user" ? "You" : "Alisha"}
                  </Typography>
                </Box>

                {/* User Response in blue box */}
                {item.role === "user" && (
                  <Box className="transcript-user-response-box">
                    <Typography className="transcript-user-response-text">
                      {item.text}
                    </Typography>
                  </Box>
                )}
              </ListItem>
            ))}
          </List>
        )}
      </Box>
    </Paper>
  );
}
